import type { Pfp } from '../select/picture.js';

/**
 * The blended picture layer of a profile picture (02 §1.12). The caller draws the clipping container
 * filled with the member colour; this is the layer inside it.
 * - An uploaded photo is shown in greyscale so it reads as tinted by the member colour.
 * - A preset picture is ready-made art, shown as is; `grain` adds the noise the design puts
 *   over presets in the day tiles, the island centre and the profile header.
 * - `p.blend` says whether the layer is multiplied into the colour (grey art, photos) or drawn as is.
 */
export function Picture({ p, grain = false }: { readonly p: Pfp; readonly grain?: boolean }) {
  return <span aria-hidden="true" style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%', mixBlendMode: p.blend }}>
    {p.url && <img alt="" src={p.url} draggable={false} style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%', objectFit: 'cover', ...(p.preset ? {} : { filter: 'grayscale(1) contrast(1.05)' }) }} />}
    {grain && p.preset && p.url && <svg width="100%" height="100%" style={{ position: 'absolute', left: 0, top: 0 }}>
      <rect x="0" y="0" width="100%" height="100%" filter="url(#grain)" style={{ opacity: 0.3 }} />
    </svg>}
  </span>;
}
